import { TimeEntryRM } from '@herbjoy/apex-api-models';
import { ILogService, IOnInit } from 'angular';
import { TimeEntryService } from '../../../core/services';
import { UtilityService } from '../../../core/services/utility.service';
import { CancelValue, ValueEmitter } from '../../shared/modals/modal-types';
import templateUrl from './delete-time-entry-modal.component.html';

export const DeleteTimeEntryModalComponent = {
    templateUrl,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    controller: class DeleteTimeEntryModalComponent implements IOnInit {
        resolve: any;
        close: () => void;
        dismiss: ValueEmitter<CancelValue>
        timeEntry: TimeEntryRM;
        employeeName: string;
        additionalMealBreakPluralization = {
            0: '',
            one: 'and its associated meal break',
            other: 'and its {} associated meal breaks'
        };
        constructor(private $log: ILogService, private timeEntryService: TimeEntryService,
            private utilityService: UtilityService) {
            'ngInject'
        }
        $onInit() {
            this.employeeName = this.resolve.employeeFullName;
            this.utilityService.showLoading();
            this.timeEntryService.retrieveTimeEntry(this.resolve.timeEntryID)
                .then(timeEntry => {
                    this.timeEntry = timeEntry;
                })
                .catch(ex => {
                    if (ex.status === 404) {
                        this.$log.info(`Time entry ${this.resolve.timeEntryID} was already deleted or does not exist`)
                        // The time entry doesn't exist, so no need to display anything.
                        this.close();
                        return;
                    }
                    this.$log.error(ex);
                    alert("Loading comments failed.");
                })
                .then(() => this.utilityService.hideLoading());
        }

        onSubmit() {
            const deleting = this.timeEntryService.deleteTimeEntry(this.resolve.timeEntryID, {
                Comments: this.timeEntry.Comments || ""
            })
            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(deleting, "Delete failed")
            );
            deleting.then(() => this.close());
        }

        cancel() {
            this.dismiss({ $value: 'cancel' });
        }
    }
}
